import { render, staticRenderFns } from "./DispatchV2.html?vue&type=template&id=aaf8184c&scoped=true&external"
import script from "./DispatchV2.js?vue&type=script&lang=js&external"
export * from "./DispatchV2.js?vue&type=script&lang=js&external"
import style0 from "./DispatchV2.vue?vue&type=style&index=0&id=aaf8184c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf8184c",
  null
  
)

export default component.exports